import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Transition } from "@headlessui/react";
import ProcessingBar2 from "../../../../components/ProcessingBar/ProcessingBar2";

const SecondBarber = () => {
  const steps = [
    {
      title: "24/7 self-booking made easy.",
      description:
        "Let clients schedule appointments anytime through Instagram, Facebook, or your website — no calls, no hassle.",
    },
    {
      title: "Never waste a cancellation.",
      description:
        "Turn last-minute cancellations into revenue with smart waitlists that auto-fill open slots instantly.",
    },
    {
      title: "Maximize every working hour.",
      description:
        "Boost staff productivity and profits by controlling gaps — allow bookings only before or after existing appointments.",
    },
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let count = 0;

    const timer = setInterval(() => {
      count += 1;
      setProgress(count * 10);

      if (count >= 10) {
        setCurrentStep((prev) => (prev + 1) % steps.length);
        count = 0;
        setProgress(0);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleTitleClick = (index) => {
    setCurrentStep(index);
    setProgress(0); // reset progress when user manually selects
  };

  const navigate = useNavigate();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showProcessingCall, setShowProcessingCall] = useState(false);

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  const handleBookACall = () => {
    setShowProcessingCall(true);
    setTimeout(() => {
      setShowProcessingCall(false);
      navigate("/contact/book-a-call");
    }, 2000);
  };

  return (
    <div className="bg-dry py-20 px-4">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16">
        {/* Left Content */}
        <div className="md:w-1/2">
          <h2 className="text-4xl md:text-5xl font-bold text-text mb-6">
            Smart bookings.
            <br />
            No empty chairs.
          </h2>

          <p className="text-sm text-textGray mb-6">
            Keep your barbers busy and your shop buzzing. Fill last-minute
            cancellations, reduce downtime, and let Lokalai handle bookings
            while you focus on the cuts.
          </p>

          <div className="transition-opacity duration-700 opacity-100 ">
            <div className="h-[220px]">
              {steps.map((step, index) => (
                <div key={index} className="mb-8">
                  <h3
                    onClick={() => handleTitleClick(index)}
                    className={`cursor-pointer font-semibold text-lg ${
                      index === currentStep ? "text-redlight" : "text-textGray"
                    }`}
                  >
                    {step.title}
                  </h3>

                  <Transition
                    show={index === currentStep}
                    enter="transition-opacity duration-100"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="mt-2 text-text text-sm">
                      {step.description}
                    </div>
                  </Transition>
                  {/* Progress bar directly under title */}
                  {index === currentStep && (
                    <div className="w-full h-[2px] mt-2 bg-dry rounded-full overflow-hidden">
                      <div
                        className="h-full bg-redlight transition-all duration-1000 ease-linear"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="flex flex-row sm:flex-row items-start sm:items-center gap-4">
              <button
                onClick={handleregister}
                className="bg-redlight text-text px-6 py-3 rounded-full font-semibold text-sm transition-transform duration-200 hover:scale-105 w-[200px] h-[45px]"
              >
                {showProcessing ? (
                  <div className="flex items-center justify-center w-full h-full">
                    <ProcessingBar2 />
                  </div>
                ) : (
                  "Start 30-day free"
                )}
              </button>

              <button
                onClick={handleBookACall}
                className="relative text-text text-sm font-semibold pb-1 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:bg-text after:transition-all after:duration-200 hover:after:w-0 min-w-[100px] h-[40px] flex items-center justify-center"
              >
                {showProcessingCall ? <ProcessingBar2 /> : "Talk to us"}
              </button>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://images.pexels.com/photos/3998399/pexels-photo-3998399.jpeg"
              alt="Booking Calendar"
              className="w-full object-cover grayscale"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondBarber;
